export default "__VITE_ASSET__C$chthdl__"